import { Collectible, Project, StrapiMedia } from '@portals/api';

export type Collection = {
	id?: number;
	name: string;
	collectibles?: Collectible[] | number[];
	project?: Project;
	image?: StrapiMedia;
};
